import { render } from "./captcha.vue?vue&type=template&id=6a98ab55&ts=true"
import script from "./captcha.vue?vue&type=script&lang=ts"
export * from "./captcha.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__